import MinuteByMinute from './view';

const MinuteByMinutePage = {
    name: 'MinuteByMinute',
    list: MinuteByMinute
};

export default MinuteByMinutePage;